import BaseComponent from '../BaseComponent';
import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'MatchDetailsEdit';

const SELECTOR_PAGE = '.lta-match-details-edit';
const SELECTOR_TRIGGER_EXIT_BUTTON = '.js-exit-match-details-edit-modal';
const SELECTOR_TRIGGER_CANCEL_BUTTON = '.js-cancel-match-details-edit-modal';
const SELECTOR_TRIGGER_SAVE_BUTTON = '.js-save-match-details-edit-modal';

const EVENT_CLICK = `click`;

class MatchDetailsEdit extends BaseComponent {

	constructor(element) {
		super(element);
		this._saveCallbacks = [];
		this._cancelCallbacks = [];
		this.init();
	}
	static get NAME() {
		return NAME;
	}

	init() {
		this._wrapperElement = SelectorEngine.findOne(SELECTOR_PAGE);

		if (!this._wrapperElement) {
			return;
		}

		this._matchDetailsModalExitButton = SelectorEngine.findOne(SELECTOR_TRIGGER_EXIT_BUTTON, this._wrapperElement);
		this._matchDetailsModalCancelButton = SelectorEngine.findOne(SELECTOR_TRIGGER_CANCEL_BUTTON, this._wrapperElement);

		this._matchDetailsModalsaveButton = SelectorEngine.findOne(SELECTOR_TRIGGER_SAVE_BUTTON, this._wrapperElement);

		EventHandler.on(this._matchDetailsModalExitButton, EVENT_CLICK, this.onCancelClickHandler.bind(this));
		EventHandler.on(this._matchDetailsModalCancelButton, EVENT_CLICK, this.onCancelClickHandler.bind(this));

		EventHandler.on(this._matchDetailsModalsaveButton, EVENT_CLICK, this.onSaveClickHandler.bind(this));
		const forms = document.querySelectorAll('.game-default--form-element');

		forms && forms.forEach((form) => {
			form.addEventListener('change', (event) => {
				this.checkForm(event);
			});
		});
	}

	set data(data = { 'sportType': '', 'tennisType': '', 'tennisBallColor': '', 'matchCategory': '' }) {
		this._data = data;
		this.updateDOM();
	}

	get data() {
		return this._data;
	}

	checkForm(event) {
		let inputChanged = event.target;
		if (inputChanged.value == 'Padel') {
			this.data.tennisType = 'Doubles';
			this.data.tennisBallColor = 'Yellow';
			Array.from(inputChanged.closest(".js-lta-section-content").nextElementSibling.querySelectorAll('input[type="radio"]'), (y, i) => {
				if (i == 1) {
					y.checked = true;
				} else {
					y.checked = false;
				}
			});
			inputChanged.closest(".js-lta-section-content").nextElementSibling.classList.add("u-hidden");
			Array.from(inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.querySelectorAll('input[type="radio"]'), (y, i) => {
				if (i == 0) {
					y.checked = true;
				} else {
					y.checked = false;
				}
			})
			inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.classList.add("u-hidden");
		} else if (inputChanged.value == 'Tennis') {
			inputChanged.closest(".js-lta-section-content").nextElementSibling.classList.remove("u-hidden");
			inputChanged.closest(".js-lta-section-content").nextElementSibling.nextElementSibling.classList.remove("u-hidden");
		}
	}

	updateDOM() {
		const matchSport = SelectorEngine.findOne("input[name='matchSport'][value=" + this.data.sportType + "]", this._wrapperElement);
		const matchTennisType = SelectorEngine.findOne("input[name='matchTennisType'][value=" + this.data.tennisType + "]", this._wrapperElement);
		const matchTennisBallColor = SelectorEngine.findOne("input[name='matchTennisBallColor'][value=" + this.data.tennisBallColor + "]", this._wrapperElement);
		const matchCategory = SelectorEngine.findOne("input[name='matchCategory'][value=" + this.data.matchCategory + "]", this._wrapperElement);

		matchSport?.setAttribute('checked', true);
		matchTennisType?.setAttribute('checked', true);
		matchTennisBallColor?.setAttribute('checked', true);
		matchCategory?.setAttribute('checked', true);
	}

	onCancel(callback) {
		this._cancelCallbacks.push(callback);
	}

	onCancelClickHandler() {
		for (const callback of this._cancelCallbacks) {
			callback();
		}
	}

	onSave(callback) {
		this._saveCallbacks.push(callback);
	}

	onSaveClickHandler() {
		const matchSport = SelectorEngine.findOne("input[type='radio'][name='matchSport']:checked", this._wrapperElement);
		const matchTennisType = SelectorEngine.findOne("input[type='radio'][name='matchTennisType']:checked", this._wrapperElement);
		const matchTennisBallColor = SelectorEngine.findOne("input[type='radio'][name='matchTennisBallColor']:checked", this._wrapperElement);
		const matchCategory = SelectorEngine.findOne("input[type='radio'][name='matchCategory']:checked", this._wrapperElement);

		const matchData = {
			'sportType': matchSport.value,
			'tennisType': matchTennisType.value,
			'tennisBallColor': matchTennisBallColor.value,
			'matchCategory': matchCategory.value
		}

		document.getElementById('sport_updated').value = matchSport.value;
		document.getElementById('ballColour_updated').value = matchTennisBallColor.value;
		document.getElementById('matchCategory_updated').value = matchCategory.value;
		document.getElementById('matchType_updated').value = matchTennisType.value;


		for (const callback of this._saveCallbacks) {
			callback(matchData);
		}
		document.getElementById('confirm-result').classList.add('u-hidden');
		document.getElementById('dispute-result').classList.remove('u-hidden');
	}
}

export default MatchDetailsEdit;
